import { resolutions } from './constants';

export const initialHistory = {
  time: [],
  humidity: [],
  temp: [],
  co2: [],
  vpd: [],
  temp_leaf_current: [],
  vol_water_content: [],
  ec_root_zone: [],
  hidden: {
    humidity: false,
    temp: false,
    co2: true,
    vpd: true,
    temp_leaf_current: true,
    vol_water_content: true,
    ec_root_zone: true
  },
  resolution: resolutions.daily,
  progress: 0,
  last_ts: 0,
  pending_data: []
};

export const initialFSStatus = {
  total_size: -1,
  free: -1,
  flash_status: -1,
  fs_status: -1
};
